import { passUrlToAppleAppBanner } from '@/plugins/apple-app-banner'
import '@whispli/loading';

(async () => {
  passUrlToAppleAppBanner()

  const [
    ,
    { createApp },
    { default: init },
  ] = await Promise.all([
    import('@/sw'),
    import('@whispli/ui'),
    import('@/init'),
  ])

  await createApp(init)
})()

if (import.meta.hot) {
  import.meta.hot.accept()
}
